import { lazy } from "@loadable/component";
import { Suspense } from "react";
import { ErrorBoundary } from "@sentry/react";
import { ErrorFallback } from "../../patterns";
import { CustomFormLoading } from "./CustomForm.loading";
import { CustomFormProps } from "./CustomForm.types";

export const CustomFormLoadable = lazy(() => import("./CustomForm"));

export const CustomForm = (props: CustomFormProps) => (
  <ErrorBoundary fallback={<ErrorFallback />}>
    <Suspense fallback={<CustomFormLoading />}>
      <CustomFormLoadable {...props} />
    </Suspense>
  </ErrorBoundary>
);
